module.exports = __webpack_public_path__ + "static/media/_T3-Docker.67a436a9.svg";